import { FormControl, MenuItem, Select } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";

import { setReportInterval } from "app/store/transmission/slice/transmissionSlice";
import { REPORT_INTERVAL_OPTIONS } from "static/constants";

const ReportIntervalFilter = () => {
  const { reportInterval, useReportIntervalFilter } = useSelector(
    (state) => state.transmission
  );
  const dispatch = useDispatch();

  return (
    useReportIntervalFilter && (
      <div
        style={{
          justifyContent: "flex-end",
          display: "flex",
          alignItems: "center",
          gap: "3px",
          marginRight: "5px",
        }}
      >
        <span style={{ fontSize: "0.875rem" }}>
          You are currently viewing the reports from last{" "}
        </span>
        <FormControl sx={{ m: 1, minWidth: 110 }} size="small">
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={reportInterval}
            onChange={(e) => dispatch(setReportInterval(e.target.value))}
            sx={{ fontSize: "0.875rem" }}
          >
            {REPORT_INTERVAL_OPTIONS.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
    )
  );
};

export default ReportIntervalFilter;
